module.exports = __webpack_public_path__ + "img/Voucher_Complete.c0792e4a.png";